import {useEffect, useState} from 'react';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import requestGetFilterPositions from '@/src/jobPortal/common/utils/requestGetFilterPositions';

export interface FilterPositionsProps {
  id: number | string;
  name_en: string;
  name_de: string;
}
const useFilterPositions = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [positions, setPositions] = useState<FilterPositionsProps[]>([]);

  const fetchFilterTypePositions = async () => {
    setIsLoading(true);

    const {responseBody, status} = await requestGetFilterPositions();

    if (status === RESPONSE_STATUSES.SUCCESS) {
      setPositions(responseBody.data);
    }

    setIsLoading(true);
  };

  useEffect(() => {
    fetchFilterTypePositions();
  }, []);

  return {
    positions,
    isLoading,
  };
};

export default useFilterPositions;
